import { gql } from "@apollo/client";

export const REFERENCES = gql`
  query ReferencesQuery(
    $limit: Int
    $offset: Int
    $where: ReferencesFiltersInput!
  ) {
    references(limit: $limit, offset: $offset, where: $where) {
      ok
      error
      hasMore
      total
      results {
        id
        name
        url
        imgUrl
        reference
        lastQuantity
        lastPrice
        userId
        user {
          id
          firstname
          lastname
          email
        }
        products {
          id
          productId
          product {
            id
            name
            site {
              id
              name
            }
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const REFERENCE = gql`
  query ReferenceQuery($id: Int!) {
    reference(id: $id) {
      ok
      error
      result {
        id
        name
        url
        imgUrl
        reference
        lastQuantity
        lastPrice
        userId
        user {
          id
          firstname
          lastname
          email
        }
        products {
          id
          productId
          product {
            id
            name
            url
            imgUrl
            reference
            lastPrice
            lastQuantity
            site {
              id
              name
            }
          }
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const CREATE_REFERENCE = gql`
  mutation CreateReferenceMutation($input: CreateReferenceInput!) {
    createReference(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_REFERENCE = gql`
  mutation UpdateReferenceMutation($id: Int!, $input: UpdateReferenceInput!) {
    updateReference(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_REFERENCE = gql`
  mutation RemoveReferenceMutation($id: Int!) {
    removeReference(id: $id) {
      ok
      error
    }
  }
`;

export const LINK_PRODUCT_TO_REFERENCE = gql`
  mutation LinkProductToReferenceMutation(
    $referenceId: Int!
    $productId: Int!
  ) {
    linkProductToReference(referenceId: $referenceId, productId: $productId) {
      ok
      error
      id
    }
  }
`;

export const UNLINK_PRODUCT_FROM_REFERENCE = gql`
  mutation UnlinkProductFromReferenceMutation(
    $referenceId: Int!
    $productId: Int!
  ) {
    unlinkProductFromReference(
      referenceId: $referenceId
      productId: $productId
    ) {
      ok
      error
    }
  }
`;
